export default __webpack_public_path__ + "static/media/car.7ed0c2b7.svg";